import React from 'react'

/**
 * Created by @author @ddennis - ddennis.dk aka fantastisk.dk/works aka meresukker.dk on 02/10/2023.
 */

export const removeDots = (str) => {
  return str.replace('.', '')
}
export const addDots = (amount) => {
  const parts = amount.toString().split('.')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return parts.join('.')
}

export const PriceBox = ({ price }) => {
  const example = price?.example || '0'
  const ikeaExample = price?.ikeaExample || '0'
  const extra = price?.extra || '0'
  const txt = price?.txt || '-'
  console.log('PriceBox >  parseInt(extra) = ', parseInt(extra))

  const total = parseInt(removeDots(example)) + parseInt(removeDots(ikeaExample)) + parseInt(removeDots(extra))

  return (
    <div className="me-5 ">
      <h6 className="fw-bold mb-2">Priseksemple:</h6>

      <p className="p-small ">
        {txt} <span className="fw-bold"> {example} ,-</span>
      </p>

      <p className="p-small opacity-75">Sidebeklædninger og sokkel: {extra},-</p>
      <p className="p-small opacity-75">IKEA kabinetter og skuffer: {ikeaExample},-</p>
      <div className="bg-black  my-1" style={{ opacity: 0.4, height: 1 }}></div>
      <p className="p-small opacity-75">Ialt: {total},-</p>
    </div>
  )
}
